import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import logo from '../assets/logo.png';
import pozadi from '../assets/login-background.jpg';
import api from '../services/api';
import './Login.css';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const result = await api.login(email, password);
      if (result.data?.token) {
        onLogin(result.data.user, result.data.permissions || []);
      }
    } catch (err) {
      setError(err.message || 'Nesprávné přihlašovací údaje');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      {/* Fotka jde do vlastní vrstvy, ne do background-image na wrapperu —
          rozmazání by jinak zasáhlo i přihlašovací formulář. */}
      <div className="login-pozadi" style={{ backgroundImage: `url(${pozadi})` }} aria-hidden="true" />

      <div className="login-box">
          <div className="text-center mb-4">
            <img src={logo} alt="RV System" height="30" className="mb-3" />
            <h4>Přihlášení do systému</h4>
          </div>

          {error && (
            <Alert variant="danger" className="mb-3">
              {error}
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Email nebo uživatelské jméno</Form.Label>
              <Form.Control
                type="text"
                placeholder="Email nebo uživatelské jméno"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isLoading}
                autoComplete="username"
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Heslo</Form.Label>
              <Form.Control
                type="password"
                placeholder="Zadejte heslo"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={isLoading}
              />
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Přihlašování...
                </>
              ) : (
                'Přihlásit'
              )}
            </Button>
          </Form>
      </div>
    </div>
  );
}

export default Login;
